import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/esnext.json.parse.js";
export default {
  name: "comp1",
  data() {
    return {
      typeIndex: 0,
      typebtn: [],
      alltitle: "全部",
      typeclick: false,
      ulchildSstyle: {},
      ulchildClass: "",
      ctypeArr: [],
      fid: "",
      isUseComp1: true,
      childIndex: "",
      typeOneIndex: 0
    };
  },
  components: {},
  computed: {
    computedProp() {
      return [this.$attrs.typebtnstyle, this.$attrs.posstyle];
    }
  },
  watch: {
    "$attrs.typelist": {
      handler(val) {
        this.ctypeArr = val.length > 0 ? val.map(() => {
          return "";
        }) : [];
      },
      deep: true
    },
    // '$attrs.typebtnstyle': {
    //     handler (val) {
    //         this.typebtn = [...val]
    //     },
    //     deep: true
    // },
    "$attrs.showtypeall": {
      handler(val) {
        if (this.typeclick) return;
        this.typeIndex = val ? 0 : 1;
      },
      deep: true
    },
    // '$attrs.posstyle': {
    //     handler (val) {
    //         this.getChildulStyle(val)
    //     },
    //     deep: true
    // },
    computedProp() {
      this.typebtn = [...this.$attrs.typebtnstyle];
      this.getChildulStyle(this.$attrs.posstyle);
    },
    "$attrs.activetype": {
      handler(val) {
        console.log(`this.$attrs.activetype`, val);
        if (val !== undefined && Object.keys(val).length > 0) this.setActiveIndex(val);
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.fid = this.$route.query.fid;
    // 秦都区地图分类定制
    if (this.fid === "253618") this.isUseComp1 = false;
  },
  methods: {
    /**
     * 分类点击事件
     */
    typeClick(item, index) {
      this.typeOneIndex = index;
      this.typeclick = true;
      this.typeIndex = index;
      this.childIndex = "";
      this.ctypeArr = this.ctypeArr.map(() => {
        return "";
      });
      this.$emit("typeselect", {
        index: index,
        item: item
      });
    },
    childtypeClick(item, index, child, cIndex) {
      this.typeIndex = index;
      this.childIndex = cIndex;
      this.ctypeArr = this.ctypeArr.map(() => {
        return "";
      });
      this.ctypeArr[index - 1] = cIndex;
      this.$emit("typeselect", {
        index: index,
        item: item,
        child: child,
        cIndex: cIndex
      });
    },
    getChildren(item, type) {
      let nextLevel = [];
      if (item?.itemformdata?.json != null && item.itemformdata.json !== '') {
        nextLevel.push(...JSON.parse(item.itemformdata.json.replace(/(<\/?p.*?>)/gi, "")));
      }
      return type === 0 ? nextLevel.length > 0 : nextLevel;
    },
    getChildulStyle(val) {
      // const margin = 0
      const margin = this.typebtn.length > 0 && this.typebtn[0].margin !== undefined ? Number(this.typebtn[0].margin.replace("vw", "")) : 0;
      let style = {};
      if (val.display && val.display === "flex") {
        style.left = "-50%";
        if (val.top) style.top = "100%";
        if (val.bottom) style.bottom = "100%";
        this.ulchildClass = "";
      } else if (!val.display || val.display && val.display === "block") {
        if (val.left) style.left = "100%";
        if (val.right) style.right = `100%`;
        style.width = `calc(100% + ${margin * 2}vw)`;
        this.ulchildClass = "normal";
      }
      // console.log(`this.typebtn`, this.typebtn)
      this.ulchildSstyle = style;
    },
    /**
     * 设置激活分类
     */
    setActiveIndex(val) {
      this.typeOneIndex = val.index;
      this.typeIndex = val.index;
      this.childIndex = val.cIndex !== undefined ? val.cIndex : '';
    }
  }
};